// extracted by mini-css-extract-plugin
export default {"bankIDPopup":"styles_bankIDPopup__jSmTZ"};